module.exports = __webpack_public_path__ + "static/media/facebook_icon.9f6904e4.svg";